import { render, staticRenderFns } from "./LongerThan.vue?vue&type=template&id=29e955ce&"
import script from "./LongerThan.vue?vue&type=script&lang=js&"
export * from "./LongerThan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports